import qs from "query-string";
import PASentry from "util/pa-sentry";
import { getNextQuery } from "./getNextQuery";

export function getHrefAndAspath(href: any, path: any, query: any) {
  const QS = typeof query === "string" ? query : qs.stringify(query);
  const nextQuery = getNextQuery(QS);
  if (!path || path === "undefined") {
    PASentry.logException(new Error("aspath is undefined"), null, {
      href, path, nextQuery, hrefandaspath: true, hrefandaspathType: typeof path,
    });
  }
  return {
    href: QS.length ? `${href}?${nextQuery}` : href,
    asPath: QS.length ? `${path}?${QS}` : path,
  };
}
